// @ts-check

/**
 * Handles "Select All" checkbox functionality.
 * @param {HTMLInputElement} source - The "Select All" checkbox element.
 * @param {string} name  - The name attribute of the checkbox group. Defaults to the source's name.
 * @returns {void}
 */
//export const checkboxSelectAll = (source, name = source.name) => {
//    /**
//     * @type {NodeListOf<HTMLInputElement>}
//     */
//    const checkboxes = document.querySelectorAll(`input[name='${name}']`);
//    checkboxes.forEach((checkbox) => {
//        if (checkbox !== source) {
//            checkbox.checked = source.checked;
//        }
//    });
//};

/** Handles automatic form submission on change.
 * @param {HTMLFormElement} source - The form element that triggered the change event.
 * @param {number|string|null} [pageNumber=null] - Optional page number to include.
 * @returns {void}
 */
export const autoSubmitForm = (source, pageNumber = null) => {
    if (source instanceof HTMLFormElement) {
        // Read attribute values from source
        var containerName = source.getAttribute('data-results-container');
        var resultsContainer = document.getElementById(containerName);
        var containerName = source.getAttribute('data-search-container');
        var scrollTarget = document.getElementById(containerName);

        const stickyHeader = document.getElementById('header'); 

        if (!resultsContainer) {
            console.error("Target container 'funding-search-results' not found!");
            return; // Stop if the container doesn't exist
        }

        // 1. Gather Data and Build Query String
        const formData = new FormData(source);
        const searchInput = document.getElementById('funding-search-text');

        if (pageNumber !== null) {
            // Assuming the page parameter name is 'p', as per your original URL example: ?p=1
            formData.append('p', pageNumber);
        }

        // Check if the element exists and has a non-empty value
        if (searchInput && searchInput.value) {
            // Append the external value to the FormData object
            // The key will be 'q', as requested in the URL example: ?q=search-text
            formData.append('q', searchInput.value);
        }

        // Convert FormData to a URL-encoded query string
        const queryString = Array.from(formData.entries())
            .map(([key, value]) => {
                // Encode key and value to be URL-safe
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            })
            .join('&');

        const language = source.getAttribute('data-language') || document.documentElement.lang || 'en';
        const baseUrl = source.action; 
        const fullUrl = `${baseUrl}?${queryString}`;

        fetch(fullUrl, {
            method: 'GET',
            headers: {
                'Accept-Language': language,
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                if (!response.ok) {
                    // Throw an error if the server response is not OK (e.g., 404, 500)
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                // Tell fetch to read the response body as plain text (the HTML partial)
                return response.text();
            })
            .then(htmlPartial => {
                // Use innerHTML to replace the entire content of the target div
                resultsContainer.innerHTML = htmlPartial;

                // When clicking pagination, scroll back up
                if (scrollTarget && pageNumber) {
                    const rect = scrollTarget.getBoundingClientRect();
                    const headerHeight = stickyHeader ? (stickyHeader.offsetHeight + 50) : 0;
                    const targetPosition = window.scrollY + rect.top - headerHeight;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            })
            .catch(error => {
                console.error("Form submission failed:", error);
                // Optional: Display an error message to the user
                resultsContainer.innerHTML = `<p class="error-message">Sorry, we couldn't load the results. Please try again.</p>`;
            });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    // Bind all search forms on the page
    const listItemsForms = document.querySelectorAll('[data-element-type=funding-search-container]');

    if (listItemsForms) {
        listItemsForms.forEach(formElement => {
            // Get button, filters and results
            const submitButton = formElement.querySelector('[data-element-type=funding-search-submit]');
            const filterForm = formElement.querySelector('[data-element-type=form-funding-search-filters]');
            const staticResultsContainer = formElement.querySelector('[data-element-type=funding-search-results]'); 

            // Bind submit button, if any
            if (submitButton && filterForm) {
                submitButton.addEventListener('click', (event) => {
                    event.preventDefault();

                    // Manually call the autoSubmitForm function, passing the filter form element
                    autoSubmitForm(filterForm);
                });
            }

            // Bind pagination, if any
            if (staticResultsContainer && filterForm) {
                staticResultsContainer.addEventListener('click', (event) => {
                    const anchor = event.target.closest('a[data-page]');

                    if (anchor) {
                        event.preventDefault(); // Stop the link from navigating/postback
                        const page = anchor.getAttribute('data-page');
                        autoSubmitForm(filterForm, page);
                    }
                });
            }

            // Bind sorting, if any
            // Sorting
            const applicationSortToggle = formElement.querySelector("[data-element-type=application-sort-dropdown-toggle]");
            const applicationSortLabel = formElement.querySelector("[data-element-type=application-sort-dropdown-label]");
            const applicationSortMenu = formElement.querySelector("[data-element-type=application-sort-dropdown-menu]");

            if (applicationSortToggle && applicationSortLabel && applicationSortMenu) {
                applicationSortToggle.addEventListener("click", (e) => {
                    e.stopPropagation();
                    applicationSortMenu.classList.toggle("hidden");
                });

                // Optional: Hide dropdown when clicking outside
                document.addEventListener("click", () => {
                    applicationSortMenu.classList.add("hidden");
                });

                // Prevent closing when clicking inside the menu
                applicationSortMenu.addEventListener("click", (e) => {
                    e.stopPropagation();
                });

                // Handle sort option click
                applicationSortMenu.querySelectorAll("button[data-sort]").forEach(btn => {
                    btn.addEventListener("click", function () {
                        const sortType = this.getAttribute("data-sort");
                        const sortText = this.textContent.trim();

                        // Set the button's text and value
                        applicationSortLabel.textContent = sortText;
                        applicationSortToggle.setAttribute("data-sort", sortType);

                        applicationSortMenu.classList.add("hidden");

                        // Add the sort filter
                        var sortFilter = filterForm.querySelector("#sort");

                        if (sortFilter) {
                            sortFilter.value = sortType;
                        }

                        // Call the search methos to fetch items sorted
                        autoSubmitForm(filterForm);
                    });
                });
            }
        });
    }
});
